import type { FontSize } from '../../types'
import * as tokens from './generated-tokens/ts/font-size'

// @TODO: Decide on object key naming for these
export const fontSize: FontSize = {
  [12]: tokens.SbFontSize12,
  [14]: tokens.SbFontSize14,
  [16]: tokens.SbFontSize16,
  [17]: tokens.SbFontSize17,
  [18]: tokens.SbFontSize18,
  [19]: tokens.SbFontSize19,
  [21]: tokens.SbFontSize21,
  [22]: tokens.SbFontSize22,
  [24]: tokens.SbFontSize24,
  [25]: tokens.SbFontSize25,
  [28]: tokens.SbFontSize28,
  [30]: tokens.SbFontSize30,
  [33]: tokens.SbFontSize33,
  [34]: tokens.SbFontSize34,
  [40]: tokens.SbFontSize40,
  [48]: tokens.SbFontSize48,
}
